import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemIconComponent } from '../access-item-icon/access-item-icon.component';
import { AccessItemComponent } from '../access-item/access-item.component';
import { GallerySettingsIconComponent } from '../gallery-settings-icon/gallery-settings-icon.component';

@Component({
  selector: 'app-theme-cover-item',
  imports: [
    AccessItemComponent,
    AccessItemIconComponent,
    GallerySettingsIconComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    ButtonDirective,
    SvgComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-cover-item.component.html',
  styleUrl: './theme-cover-item.component.scss',
})
export class ThemeCoverItemComponent {
  customize = output();
}
